import { gql } from '@apollo/client'
import { USER_FRAGMENT } from '../fragments'

export const GET_STORE_GROUPS = gql`
  query StoreGroups($input: StoreGroupInput!) {
    storeGroups(input: $input) {
      count
      results {
        name
        id
        assignedTo {
          ...User
        }
        parentGroup {
          name
        }
        groupType
        storeList {
          name
        }
        region {
          name
        }
      }
    }
  }
  ${USER_FRAGMENT}
`
